import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FilterNav from '../../molecules/filterNav/FilterNav';
import styles from './SearchItemContainer.module.scss';
import { Row, Col, CustomContainer } from "../../atoms/DependencyHelper";
import config from "../../../config/index";
import ButtonBox from '../../atoms/buttonBox/ButtonBox';

const ContractTypeMobile = (props) => {
    const imagePrefix = config.envConfigs[config.env].imagePrefix;
    let [selectedContract, setSelectedContract] = useState('');
    let [contractSelectMobile, setContractSelectMobile] = useState({});

    const resetContractType = () => {
      props.setSelectedFilter(props.tempSelectedFilter);
    };
    const handleBack = () => {
      resetContractType();
      props.hideContractType();
    }


    useEffect(() => {
        if (props?.filteredContractType && props?.filteredContractType[0].label) {
            setSelectedContract(props?.filteredContractType[0].label);
        } else {
          setSelectedContract('');
        }
    }, [props.filteredContractType]);

    const handleContractSelectMobileClick = (flag, itemValue, itemLabel, item) => {
        setContractSelectMobile({
            flag: flag,
            itemValue: itemValue,
            itemLabel: itemLabel
        });
        props.contracttypeClickHandler(true, item)

    }
    const getDescription = (label) => {
        for (let i = 0; i <= props?.contractsList?.length; i++) {
          if (props?.contractsList[i]?.contract_type_option_label.toLowerCase() === label.toLowerCase()) {
            return props?.contractsList[i]?.contract_type_desc;
          }
        }
      }

    return (
      <div className={styles.navGutter}>
        <FilterNav
          headingName="Contract type"
          backbtn={handleBack}
          resetClickHandler={props.resetClickHandler}
          selectedFilter={props.filteredContractType}
        />
        <CustomContainer className={styles["contract-type"]}>
          {props?.contracttypes &&
            props?.contracttypes
              ?.sort((a, b) => a.value - b.value)
              ?.map((item, index) => (
                <CustomContainer
                  key={`contract_type_${index}`}
                  className={`${styles["contract-type__modal"]}
                              ${
                                styles[
                                  item.label === selectedContract
                                    ? "contract-type__modal_bgColor"
                                    : ""
                                ]
                              }`}
                  id={`${item.label}`}
                >
                  <div
                    onClick={() =>
                      handleContractSelectMobileClick(
                        true,
                        item.value,
                        item.label,
                        item
                      )
                    }
                    className={styles["contract-type__modal__label"]}
                  >
                    <Row>
                      <Col xs={10}>
                        <div
                          className={
                            styles["contract-type__modal__label__title"]
                          }
                        >
                          {item.label}
                        </div>
                        <div
                          className={
                            styles["contract-type__modal__label__description"]
                          }
                        >
                          {" "}
                          {getDescription(item.label)}
                        </div>
                      </Col>
                      <Col
                        xs={2}
                        className={
                          styles["contract-type__modal__label__success-icon"]
                        }
                      >
                        {item.value === contractSelectMobile.itemValue ||
                          (item.label === selectedContract && (
                            <img
                              src={`${imagePrefix}/assets/images/good.svg`}
                              alt="selected"
                              className={styles["check-mark"]}
                            />
                          ))}
                      </Col>
                    </Row>
                  </div>
                </CustomContainer>
              ))}
        </CustomContainer>
        <ButtonBox
          children="Save Selection"
          className={styles["botton-box"]}
          click={props.hideContractType}
        />
      </div>
    );
};

ContractTypeMobile.propTypes = {
    contracttypeClickHandler: PropTypes.func,
    hideContractType: PropTypes.bool,
    contracttypes: PropTypes.array,
    resetClickHandler: PropTypes.func,
    filteredContractType: PropTypes.array,
    contractsList:PropTypes.array,
};

export default ContractTypeMobile;